import { z } from "zod";
export const PAYMENT_STATUSES = ["pending", "paid", "failed", "refunded"];
export const paymentStatusSchema = z.enum(PAYMENT_STATUSES);
export const PaymentStatusEnum = {
    PENDING: "pending",
    PAID: "paid",
    FAILED: "failed",
    REFUNDED: "refunded",
};
